type Key<T> = keyof T;

export const objectDeepFreeze = <T extends object>(object: T): DeepReadonly<T> => {
    objectKeys(object).forEach((key) => {
        if (typeof object[key] === 'object') {
            objectDeepFreeze(object[key]);
        }
    });
    return Object.freeze(object);
};

export type DeepReadonly<T> = {
    readonly [key in keyof T]: DeepReadonly<T[key]>;
};

const objectKeys = <T extends object>(object: Required<T>): Key<T>[] => Object.keys(object) as Key<T>[];
